import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var UserStatus;
(function (UserStatus) {
    UserStatus["Active"] = "ACTIVE";
    UserStatus["Inactive"] = "INACTIVE";
})(UserStatus || (UserStatus = {}));
export const UserStatusMap = new Map([
    [UserStatus.Active, 'Global.Status.Active'],
    [UserStatus.Inactive, 'Global.Status.Inactive'],
]);
let UserStatusService = class UserStatusService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = UserStatusMap;
    }
    list() {
        return this._data;
    }
    get(status) {
        const s = this._data.get(status);
        return s ? this._translate.instant(s) : s;
    }
    getStyleClass(status) {
        switch (status) {
            case UserStatus.Active:
                return 'text-success';
            case UserStatus.Inactive:
                return 'text-danger';
            default:
                return '';
        }
    }
    getBadgeClass(status) {
        switch (status) {
            case UserStatus.Active:
                return 'badge badge_success';
            case UserStatus.Inactive:
                return 'badge badge_danger';
            default:
                return 'badge badge_default';
        }
    }
};
UserStatusService.ctorParameters = () => [
    { type: TranslateService }
];
UserStatusService = __decorate([
    Injectable({ providedIn: 'root' }),
    __metadata("design:paramtypes", [TranslateService])
], UserStatusService);
export { UserStatusService };
